<template>
  <v-col md="1" cols="1">
    <v-btn class="btn-add-category" @click="editHighlight">
      <img v-if="!highlightEdit" src="@/assets/img/plus-icon.png" alt="icon">
      <slot></slot>
    </v-btn>
    <v-dialog v-model="highlightDialog" max-width="940">
      <v-card class="modal canyon-modal">
        <div class="modal-head">
          <template v-if="!highlightEdit">
            {{ $t('Добавление') }}
          </template>
          <template v-else>
            {{ $t('Редактирование') }}
          </template>
          <v-btn color="modal-close" @click.native="resetHighlightAdd(false)">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="tab-main">
            <v-form
              class="form-ru"
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="createHighlight"
            >
              <v-tabs
                background-color="white"
                left
                v-model="langHighlightTab"
              >
                <v-tab>Русский</v-tab>
                <v-tab>Кыргызча</v-tab>
                <v-tab>English</v-tab>
                <v-tab-item v-for="tabItem in tabItems" :key="tabItem.description">
                  <div :class="{ 'form-label-copy': !tabItem.main }">
                    <v-row v-if="tabItem.main" :class="{invalid: $v.highlight.number.$error}">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Номер') }}: <span v-if="tabItem.main" class="asterix">*</span>
                          <fieldInfo :info="$t('Номер')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model="highlight[tabItem.number]"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main" :class="{invalid: $v.highlight.square.$error}">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Площадь') }}: <span v-if="tabItem.main" class="asterix">*</span>
                          <fieldInfo :info="$t('Площадь')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model.number="highlight[tabItem.square]"
                          type="number"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Площадь водно-болотистых угодий') }}:
                          <fieldInfo :info="$t('Площадь водно-болотистых угодий')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model.number="highlight[tabItem.wetlandAreaSquare]"
                          type="number"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Площадь земельных участков') }}:
                          <fieldInfo :info="$t('Площадь земельных участков')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model.number="highlight[tabItem.landAreaSquare]"
                          type="number"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Принадлежность к зонам') }}:
                          <fieldInfo :info="$t('Принадлежность к зонам')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-select
                          :items="ooptZones"
                          return-value
                          item-value="id"
                          item-text="transName"
                          v-model="highlight[tabItem.ooptZone]"
                          multiple
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Выбор зоны') }}:
                          <fieldInfo :info="$t('Выбор зоны')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-select
                          :items="zoneSelections"
                          return-value
                          item-value="id"
                          item-text="transName"
                          v-model="highlight[tabItem.zoneSelection]"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Описание') }}:
                          <fieldInfo :info="$t('Описание')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <Copy v-if="!tabItem.main" :original="highlight[tabItem.descriptionMain]"
                              @copyText="copyText($event, tabItem.description)"/>
                        <v-textarea
                          v-model="highlight[tabItem.description]"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs>
              <div class="form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Сохранить') }}
                </button>
                <button
                  class="btn btn-default gray"
                  type="button"
                  @click="resetHighlightAdd(false)"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </v-form>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import Highlight from '@/model/highlight'
import { required } from 'vuelidate/lib/validators'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'

export default {
  components: {
    Copy,
    fieldInfo
  },
  props: {
    quarterId: Number,
    highlightId: Number,
    highlightEdit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    highlightDialog: false,
    langHighlightTab: null,
    ooptZones: [],
    zoneSelections: [],
    highlight: {
      id: '',
      number: '',
      square: '',
      wetlandAreaSquare: '',
      landAreaSquare: '',
      ooptZone: '',
      zoneSelection: '',
      description: '',
      descriptionKg: '',
      descriptionEn: ''
    },
    rules: {
      highlight: {
        square: { required },
        number: { required }
      }
    },
    tabItems: [
      {
        main: true,
        number: 'number',
        square: 'square',
        wetlandAreaSquare: 'wetlandAreaSquare',
        landAreaSquare: 'landAreaSquare',
        zoneSelection: 'zoneSelection',
        ooptZone: 'ooptZone',
        description: 'description'
      },
      {
        main: false,
        number: 'number',
        square: 'square',
        wetlandAreaSquare: 'wetlandAreaSquare',
        landAreaSquare: 'landAreaSquare',
        zoneSelection: 'zoneSelection',
        ooptZone: 'ooptZone',
        descriptionMain: 'description',
        description: 'descriptionKg'
      },
      {
        main: false,
        number: 'number',
        square: 'square',
        wetlandAreaSquare: 'wetlandAreaSquare',
        landAreaSquare: 'landAreaSquare',
        zoneSelection: 'zoneSelection',
        ooptZone: 'ooptZone',
        descriptionMain: 'description',
        description: 'descriptionEn'
      }
    ],
    valid: true
  }),
  validations () {
    return this.rules
  },
  methods: {
    // Обновление формы для добавления
    resetHighlightAdd (flag) {
      this.highlightDialog = flag
      this.highlight = {
        id: '',
        number: '',
        square: '',
        wetlandAreaSquare: '',
        landAreaSquare: '',
        ooptZone: '',
        zoneSelection: '',
        description: '',
        descriptionKg: '',
        descriptionEn: ''
      }
      this.$v.$reset()
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание
    createHighlight () {
      if (!this.validateForm()) {
        return
      }
      Highlight.create(this.quarterId, this.highlight)
        .then((response) => {
          if (response.status === 201) {
            this.$noty.success(this.highlightEdit ? this.$i18n.t('Успешно обновлено') : this.$i18n.t('Успешно добавлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.$parent.fetchData()
            this.resetHighlightAdd(false)
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    editHighlight () {
      Highlight.getFormData(this.quarterId)
        .then((response) => {
          this.ooptZones = response.data.ooptZones
          this.zoneSelections = response.data.zoneSelections
        })
        .catch((error) => {
          console.log(error)
        })
      if (this.highlightEdit && this.highlightId) {
        Highlight.getEdit(this.highlightId)
          .then((response) => {
            this.highlight = response.data
            this.highlightDialog = true
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.resetHighlightAdd(true)
      }
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.highlight[refName] = title
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langCanyonTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
      )
    }
  }
}
</script>
